
export const CHECK_AUTH_TOKEN = 'app/auth/CHECK_AUTH_TOKEN';
export const CHECK_AUTH_TOKEN_RETURN = 'app/auth/CHECK_AUTH_TOKEN_RETURN';